import { debounce } from 'lodash';

const FIVE_MINUTES = 300000;

const initIdleUtils = () => {
  let timeoutId: number;
  let idle = false;

  const startTimer = () => {
    timeoutId = window.setTimeout(() => {
      idle = true;
    }, FIVE_MINUTES);
  };

  const resetTimer = debounce(() => {
    window.clearTimeout(timeoutId);

    idle = false;
    startTimer();
  }, 100);

  document.addEventListener('mousemove', resetTimer, false);
  document.addEventListener('mousedown', resetTimer, false);
  document.addEventListener('keypress', resetTimer, false);
  document.addEventListener('DOMMouseScroll', resetTimer, false);
  document.addEventListener('mousewheel', resetTimer, false);
  document.addEventListener('touchmove', resetTimer, false);
  document.addEventListener('MSPointerMove', resetTimer, false);

  startTimer();

  const isIdle = () => idle;

  return {
    isIdle,
  };
};

export const idleUtils = initIdleUtils();

export const timeout = (ms: number) =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });
